/**
 * Set value (v_) and option (o_) refs
 * @param {StorageItemProps} item
 * @param {ResolutionClusterProps} resolutions
 */
const setValueRefs = (item, resolutions) => {
  /** Set "v_{name}" ref name */
  for (const [key, value] of resolutions.get("current") || []) {
    const name = /** @type {"is-string"} */ (key);
    item.set(`v_${name}`, value);

  }

  /** Set "o_{name}" options refs */
  const data =
    /** @type {StorageItemDataProps} */ (item.get("property-data")) || null;

  if (data) {
    /** Get trigger */
    const trigger = /** @type {TriggerProps} */ (data.get("trigger"));

    /** Set `t_trigger` ref */
    item.set("t_trigger", trigger);

    /** Step/Timeline options */
    const options = /** @type {OptionsMapProps} */ (data.get("options"));

    for (const [key, original] of options) {
      /** Option name */
      const name = /** @type {"duration"} */ (key);

      /** Option values */
      const values =
        /** @type {DefaultOptionMapProps & OptionsListMapProps} */ (original);

      /** Get resolutions */
      const resolutions = /** @type {any} */ (values.get("resolutions"));

      /** Get current resolution value */
      const current = resolutions.get("current").get("value");

      item.set(`o_${name}`, current);
    }
  }
};

export default setValueRefs;
